import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { SUBMIT_INVOICE_RECEIPT_EMAIL_REQUEST } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  SubmitInvoiceReceiptEmailPayload,
  SubmitInvoiceReceiptEmailResult,
} from '../types/submitReceiptEmailRequest.types';

export const submitInvoiceReceiptEmail = (builder: BuilderType) =>
  builder.mutation<SubmitInvoiceReceiptEmailResult, SubmitInvoiceReceiptEmailPayload>({
    query: (params) => ({
      data: params,
      method: 'POST',
      url: SUBMIT_INVOICE_RECEIPT_EMAIL_REQUEST,
    }),
    transformResponse(response: GenericApiResponse<SubmitInvoiceReceiptEmailResult>) {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
